export default __webpack_public_path__ + "static/media/interaction.a174cfe1.webp";